import React, { useContext, useEffect, useState } from 'react';
import { FaArrowLeft } from 'react-icons/fa6';
import { useParams, useNavigate, useLocation } from 'react-router-dom';

import SubAbasSES from './subabasSES';
import { INITIAL_FORM_SES_FICHA } from './utils/initialStates';
import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../components/BoxConteudo';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomCol from '../../../../components/CustomCol';
import { CustomSwal } from '../../../../components/CustomFeedback/CustomSwal';
import { useToast } from '../../../../components/CustomFeedback/CustomToast';
import CustomInputMask from '../../../../components/CustomInputs/CustomInputMask';
import CustomInputText from '../../../../components/CustomInputs/CustomInputText';
import CustomRow from '../../../../components/CustomRow';
import CustomSelect from '../../../../components/CustomSelects/CustomSelect';
import StyledLink from '../../../../components/Link';
import Log from '../../../../components/Log/Log';
import SubAbas from '../../../../components/SubAbas';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../../components/WorkspaceFicha';
import { getUser } from '../../../../modules/contexts/Auth/RequireAuth';
import { UserContext } from '../../../../modules/contexts/Auth/UserProvider';
import { EnumOption } from '../../../../modules/types/types';
import { clearSesMemoryCache } from '../../../../services/cache/useSesCache';
import httpClient, { isHttpError } from '../../../../services/httpClient';
import {
  getAllMunicipiosIbge,
  getSes,
} from '../../../../services/ses/sesService';
import { getSesUsuariosBySesId } from '../../../../services/ses/sesUsuarioService';
import { sanitizarForm } from '../../../../utils/functions';
import { swalSave } from '../../../../utils/swal';
import { MunicipioIbge } from '../../Fornecedores/types';

export default function SESFicha() {
  const user = getUser();
  const userID = user.sub;
  const { cudSes } = useContext(UserContext);
  // Gatilho para atualização do Log
  const [refreshTriggerLog, setRefreshTriggerLog] = useState(0);
  const triggerRefresh = () => setRefreshTriggerLog((prev) => prev + 1);

  const navigate = useNavigate();
  const location = useLocation();
  const locationData = location.state;
  const params = useParams();
  const fichaID = String(params.id);
  const { showToast } = useToast();

  //Dados do componente
  const logs = {};
  let subAbas = [];
  const [loading, setLoading] = useState(false);

  const [municipioIbgeData, setMunicipioIbgeData] = useState<MunicipioIbge[]>(
    [],
  );
  const [ufIndex, setUfIndex] = useState<string>('0');
  const [municipioOptions, setMunicipioOptions] = useState<EnumOption[]>([]);
  const [userSesData, setUserSesData] = useState<any[]>([]);
  const [responsavelId, setResponsavelId] = useState<number>(0);

  const [, setLogData] = useState({
    id: '',
    usuarioRegistro: {
      nomeCompleto: '',
    },
    usuarioAtualizacao: {
      nomeCompleto: '',
    },
    dataRegistro: '',
    dataUltimaAtualizacao: '',
    dataUltimaVisualizacao: '',
    nEdicoes: '',
    nVisualizacoes: '',
    nVisualizadores: '',
  });

  const [formSes, setFormSes] = useState(
    INITIAL_FORM_SES_FICHA(userID, locationData?.formSes),
  );

  const isEditable = !cudSes;

  const ufOptions = [
    { value: 0, label: ' - ' },
    ...municipioIbgeData
      .filter(
        (item, index, self) =>
          // Filtra apenas os itens cujas labels são únicas
          index === self.findIndex((i) => i.ufSigla === item.ufSigla),
      )
      .sort((a, b) => a.ufSigla.localeCompare(b.ufSigla))
      .map((item, index) => ({
        value: index + 1,
        label: item.ufSigla,
      }))
      .sort((a, b) => a.label.localeCompare(b.label)),
  ];

  const responsavelOptions = [
    { value: 0, label: 'Não informado' },
    ...userSesData
      // .filter((item) => item.unidadeCadastro === formProaq.componenteAF)
      .map((item) => ({
        value: item.id,
        label: item.nomeCompleto,
      })),
  ];

  //Buscar dados
  const fetchData = async (id: string) => {
    try {
      const registro = await getSes(id);
      const usuariosSesData = await getSesUsuariosBySesId(id);
      setUserSesData(usuariosSesData);
      setLogData(registro);
      setFormSes({
        id: registro.id,
        nome: registro.nome,
        cnes: registro.cnes,
        nomeEmpresarial: registro.nomeEmpresarial,
        dependencia: registro.dependencia,
        regionalSaude: registro.regionalSaude,
        tipoEstabelecimento: registro.tipoEstabelecimento,
        subtipoEstabelecimento: registro.subtipoEstabelecimento,
        gestao: registro.gestao,
        telefone1: registro.telefone1,
        telefone2: registro.telefone2,
        email: registro.email,
        site: registro.site,
        cep: registro.cep,
        bairro: registro.bairro,
        logradouro: registro.logradouro,
        complemento: registro.complemento,
        numeroImovel: registro.numeroImovel,
        observacoes: registro.observacoes,

        municipioIbgeId: registro.municipioIbge.id,
        ufSigla: registro.municipioIbge.ufSigla,
        municipio: registro.municipioIbge.municipio,
        naturezaJuridicaId: registro.naturezaJuridica.id,
        descNaturezaJuridica: registro.naturezaJuridica.naturezaJuridica,

        usuarioId: userID,
      });
      triggerRefresh(); // Dispara a atualização dos logs
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };

  const fetchOptions = async () => {
    try {
      const municipioIbgeData = await getAllMunicipiosIbge();
      setMunicipioIbgeData(municipioIbgeData);
    } catch (error: any) {
      if (isHttpError(error)) {
        CustomSwal.quick('error', error.response?.data.message);
      }
    }
  };
  useEffect(() => {
    fetchOptions();
  }, []);

  //Condicional para verificar se é necessário buscar dados e ajustar subabas
  if (fichaID !== 'undefined') {
    //Buscar dados
    useEffect(() => {
      fetchData(fichaID); // Chama a função para buscar dados quando o comp
    }, []);

    //Subabas
    subAbas = SubAbasSES(fichaID);
  } else {
    subAbas = [
      {
        label: 'Dados Gerais',
        rota: `/daf/ses/ses/ficha/dadosgerais`,
      },
    ];
  }

  // Função para buscar os municípios com base na UF selecionada
  useEffect(() => {
    const fetchMunicipiosByUf = async (ufSigla: string) => {
      if (ufSigla) {
        try {
          const municipioData = await getAllMunicipiosIbge();
          const filteredMunicipios = municipioData
            .filter((municipio) => municipio.ufSigla === ufSigla)
            .map((municipio) => ({
              value: municipio.id,
              label: municipio.municipio,
            }));
          setMunicipioOptions(filteredMunicipios);

          if (filteredMunicipios.length > 0) {
            setFormSes((prev) => ({
              ...prev,
              municipioIbgeId: filteredMunicipios[0].value,
            }));
          }
        } catch (error) {
          console.error('Erro ao obter municípios:', error);
        }
      }
    };

    fetchMunicipiosByUf(formSes.ufSigla);
  }, [formSes.ufSigla]);

  // useEffect para sincronizar uFIndex após os dados serem carregados
  useEffect(() => {
    if (formSes.ufSigla && ufOptions.length > 0) {
      const matchingOption = ufOptions.find(
        (option) => option.label === formSes.ufSigla,
      );

      if (matchingOption) {
        setUfIndex(matchingOption.value.toString());
      }
    }
  }, [formSes.ufSigla, ufOptions]);

  //Funções Handle
  const handleChange = (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    const { name, value } = event.target;
    const newValue = parseInt(value, 10);
    if (name == 'responsavel') {
      setResponsavelId(parseInt(value, 10));
    } else if (name === 'uf') {
      const uf = ufOptions.find((option) => option.value.toString() === value);
      setUfIndex(value);
      if (uf) {
        setFormSes({
          ...formSes,
          ufSigla: uf.label,
        });
      }
    } else if (name === 'municipio') {
      setFormSes({
        ...formSes,
        municipioIbgeId: newValue,
      });
    } else {
      setFormSes((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const validateForm = (form: any) => {
    const errors: string[] = [];

    // Verificar cada campo

    if (!form.cnes) {
      errors.push('Número do <b>CNES</b> é obrigatório.');
    }

    if (!form.nome) {
      errors.push('Nome do <b>Estabelecimento de Saúde</b> é obrigatório.');
    }

    if (!form.tipoEstabelecimento) {
      errors.push('<b>Tipo de Estabelecimento</b> é obrigatório.');
    }

    if (!form.gestao) {
      errors.push('<b>Gestão</b> é obrigatório.');
    }

    if (!form.dependencia) {
      errors.push('<b>Dependência</b> é obrigatório.');
    }

    if (!form.regionalSaude) {
      errors.push('<b>Regional de Saúde</b> é obrigatório.');
    }

    if (ufIndex === '0') {
      errors.push('<b>UF</b> é obrigatório.');
    }

    if (!form.municipioIbgeId) {
      errors.push('<b>Município</b> é obrigatório.');
    }

    if (errors.length > 0) {
      CustomSwal.quick('warning', errors.join('<br>')); // Exibe todas as mensagens de erro no swal
      return false;
    }

    return true; // Validação bem-sucedida
  };

  const formatForm = (form: any) => {
    const formatedForm = {
      ...form,
      telefone1: form.telefone1?.replace(/\D/g, '') || null,
      telefone2: form.telefone2?.replace(/\D/g, '') || null,
    };
    return formatedForm;
  };

  const handleCreate = async () => {
    try {
      const isFormValid = validateForm(formSes);
      if (!isFormValid) return;
      const formAjustado = formatForm(formSes);
      const formToSend = sanitizarForm(formAjustado);
      // Verificar se o formulário é válido

      // const token = 'JWT_SECRET';

      const response = await httpClient.post(`/api/ses/`, formToSend);

      swalSave();
      clearSesMemoryCache();
      setTimeout(
        () =>
          navigate(
            `/daf/ses/ses/ficha/${response.data.registro.id}/dadosgerais`,
          ),
        1000,
      );
    } catch (error) {
      if (isHttpError(error)) {
        CustomSwal.quick('error', error.response?.data.message);
      }
      console.error('Erro ao salvar registro:', error);
      CustomSwal.quick('error', 'Erro ao salvar registro.');
    }
  };

  const handleUpdate = async () => {
    try {
      const isFormValid = validateForm(formSes);
      if (!isFormValid) return;
      const formAjustado = formatForm(formSes);
      const formToSend = sanitizarForm(formAjustado);
      const response = await httpClient.patch(
        `/api/ses/${fichaID}`,
        formToSend,
      );
      clearSesMemoryCache();

      showToast(response.data.message);
      fetchData(response.data.registroAtualizado.id);
    } catch (error: any) {
      if (isHttpError(error)) {
        CustomSwal.quick('error', error.response?.data.message);
      }
      console.error('Erro ao atualizar dados', error);
    }
  };

  const handleDelete = async () => {
    CustomSwal.show({
      type: 'question',
      icon: 'warning',
      title: 'Excluir Registro?',
      html: 'Tem certeza que deseja <b>excluir</b> o registro?',
      confirmText: 'Excluir!',
      cancelText: 'Cancelar',

      onConfirm: async () => {
        try {
          await httpClient.delete(`/api/ses/${fichaID}`);
          showToast('Registro deletado com sucesso!');
          navigate('/daf/ses/ses');
        } catch (error: any) {
          if (isHttpError(error)) {
            showToast(
              error.response?.data.message ?? 'Erro ao excluir.',
              'error',
            );
          }
        }
      },

      onCancel: () => {
        showToast('A exclusão foi cancelada.', 'error', 2200);
      },
    });
  };

  //Retorno
  return (
    <>
      <SubAbas>
        <StyledLink
          to="/daf/ses/ses"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <FaArrowLeft />
        </StyledLink>
        <BarraSubAbas subAbas={subAbas} />
      </SubAbas>

      <ContainerConteudo>
        <WorkspaceFicha>
          <Log
            {...logs}
            entity="TB_SES"
            id={parseInt(fichaID, 10)}
            refreshTriggerLog={refreshTriggerLog}
          />

          <BoxConteudo boxTitulo="Dados do Estabelecimento de Saúde">
            <CustomRow style={{ marginTop: '-15px' }}>
              <CustomCol width="12%">
                <CustomInputMask
                  mask="9999999"
                  name="cnes"
                  value={formSes.cnes}
                  title="CNES"
                  onChange={handleChange}
                  required
                  readOnly={fichaID !== 'undefined'}
                />
              </CustomCol>
              <CustomCol width="43%">
                <CustomInputText
                  name="nome"
                  value={formSes.nome}
                  title="Nome do Estabelecimento"
                  onChange={handleChange}
                  required
                  readOnly={isEditable}
                />
              </CustomCol>
              <CustomCol width="45%">
                <CustomInputText
                  name="nomeEmpresarial"
                  value={formSes.nomeEmpresarial}
                  title="Nome Empresarial"
                  onChange={handleChange}
                  readOnly={isEditable}
                />
              </CustomCol>
            </CustomRow>

            <CustomRow className="d-flex justify-content-start">
              <CustomCol width="40%">
                <CustomInputText
                  name="tipoEstabelecimento"
                  value={formSes.tipoEstabelecimento}
                  title="Tipo de Estabelecimento"
                  onChange={handleChange}
                  required
                  readOnly={isEditable}
                />
              </CustomCol>
              <CustomCol width="15%">
                <CustomInputText
                  name="gestao"
                  value={formSes.gestao}
                  title="Gestão"
                  onChange={handleChange}
                  required
                  readOnly={isEditable}
                />
              </CustomCol>
              <CustomCol width="15%">
                <CustomInputText
                  name="dependencia"
                  value={formSes.dependencia}
                  onChange={handleChange}
                  title="Dependência"
                  required
                  readOnly={isEditable}
                />
              </CustomCol>
            </CustomRow>
            <CustomRow className="d-flex justify-content-start">
              <CustomCol width="40%">
                <CustomInputText
                  name="subtipoEstabelecimento"
                  value={formSes.subtipoEstabelecimento}
                  title="Subtipo de Estabelecimento"
                  onChange={handleChange}
                  readOnly={isEditable}
                />
              </CustomCol>
              <CustomCol width="35%">
                <CustomInputText
                  name="naturezaJuridica"
                  value={formSes.descNaturezaJuridica}
                  title="Descrição da Natureza Jurídica"
                  onChange={handleChange}
                  readOnly={isEditable}
                />
              </CustomCol>
              <CustomCol width="25%">
                <CustomInputText
                  name="regionalSaude"
                  value={formSes.regionalSaude}
                  title="Regional Saúde"
                  onChange={handleChange}
                  required
                  readOnly={isEditable}
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>

          <BoxConteudo boxTitulo="Contato Institucional">
            <CustomRow style={{ marginTop: '-15px' }}>
              <CustomCol md="2">
                <CustomInputMask
                  mask="(99) 99999-9999"
                  name="telefone1"
                  value={formSes.telefone1}
                  title="Telefone 1"
                  onChange={handleChange}
                  readOnly={isEditable}
                />
              </CustomCol>
              <CustomCol md="2">
                <CustomInputMask
                  mask="(99) 99999-9999"
                  name="telefone2"
                  value={formSes.telefone2}
                  title="Telefone 2"
                  onChange={handleChange}
                  readOnly={isEditable}
                />
              </CustomCol>
              <CustomCol sm="12" md="4">
                <CustomInputText
                  name="email"
                  value={formSes.email}
                  title="Email"
                  onChange={handleChange}
                  readOnly={isEditable}
                />
              </CustomCol>
              <CustomCol sm="12" md="4">
                <CustomInputText
                  name="site"
                  value={formSes.site}
                  title="Site"
                  onChange={handleChange}
                  readOnly={isEditable}
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>

          <BoxConteudo boxTitulo="Endereço">
            <CustomRow style={{ marginTop: '-15px' }}>
              <CustomCol width="12%">
                <CustomInputMask
                  name="cep"
                  mask="99999-999"
                  value={formSes.cep}
                  title="CEP"
                  onChange={handleChange}
                  readOnly={isEditable}
                />
              </CustomCol>
              <CustomCol width="8%">
                <CustomSelect
                  name="uf"
                  options={ufOptions}
                  title="UF"
                  value={ufIndex}
                  onChange={handleChange}
                  disabled={isEditable}
                  required
                />
              </CustomCol>
              <CustomCol width="40%">
                <CustomSelect
                  name="municipio"
                  options={municipioOptions}
                  title="Município"
                  value={formSes.municipioIbgeId}
                  onChange={handleChange}
                  required
                  disabled={isEditable}
                />
              </CustomCol>
              <CustomCol width="40%">
                <CustomInputText
                  name="bairro"
                  value={formSes.bairro}
                  title="Bairro"
                  onChange={handleChange}
                  readOnly={isEditable}
                />
              </CustomCol>
            </CustomRow>
            <CustomRow>
              <CustomCol width="85%">
                <CustomInputText
                  name="logradouro"
                  value={formSes.logradouro}
                  title="Logradouro"
                  onChange={handleChange}
                  readOnly={isEditable}
                />
              </CustomCol>
              <CustomCol width="15%">
                <CustomInputText
                  name="numeroImovel"
                  value={formSes.numeroImovel}
                  title="Número"
                  onChange={handleChange}
                  readOnly={isEditable}
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>

          <BoxConteudo boxTitulo="Observações" fechado>
            <CustomRow style={{ marginTop: '-15px' }}>
              <CustomCol>
                <CustomInputText
                  name="observacoes"
                  value={formSes.observacoes}
                  title=""
                  type="textArea"
                  onChange={handleChange}
                  rows={5}
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>
        </WorkspaceFicha>
      </ContainerConteudo>

      <BarraInferiorBotoes>
        {fichaID !== 'undefined' ? (
          <WorkspaceBotoes
            delete
            onClickDelete={handleDelete}
            save
            onClickSave={handleUpdate}
            saveDisabled={!cudSes}
            deleteDisabled={!cudSes}
          />
        ) : (
          <WorkspaceBotoes
            save
            onClickSave={handleCreate}
            saveDisabled={!cudSes}
          />
        )}
      </BarraInferiorBotoes>
    </>
  );
}
